<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="医院ID｛zb_hospital.id｝" prop="hospitalId" >
        <a-input v-model="form.hospitalId" placeholder="请输入医院ID｛zb_hospital.id｝" />
      </a-form-model-item>
      <a-form-model-item label="类型 1 增加 2 减少" prop="changeType" >
        <a-select placeholder="请选择类型 1 增加 2 减少" v-model="form.changeType">
          <a-select-option v-for="(d, index) in changeTypeOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="变动前华歧系数" prop="beforeScore" >
        <a-input v-model="form.beforeScore" placeholder="请输入变动前华歧系数" />
      </a-form-model-item>
      <a-form-model-item label="变动华歧系数" prop="score" >
        <a-input v-model="form.score" placeholder="请输入变动华歧系数" />
      </a-form-model-item>
      <a-form-model-item label="变动后华歧系数" prop="afterScore" >
        <a-input v-model="form.afterScore" placeholder="请输入变动后华歧系数" />
      </a-form-model-item>
      <a-form-model-item label="变动场景 字典 change_scene" prop="changeScene" >
        <a-select placeholder="请选择变动场景 字典 change_scene" v-model="form.changeScene">
          <a-select-option v-for="(d, index) in changeSceneOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getScoreRecord, addScoreRecord, updateScoreRecord } from '@/api/hospital/scoreRecord'

export default {
  name: 'CreateForm',
  props: {
    changeTypeOptions: {
      type: Array,
      required: true
    },
    changeSceneOptions: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        hospitalId: null,

        changeType: null,

        beforeScore: null,

        score: null,

        afterScore: null,

        changeScene: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        hospitalId: [
          { required: true, message: '医院ID｛zb_hospital.id｝不能为空', trigger: 'blur' }
        ],
        changeType: [
          { required: true, message: '类型 1 增加 2 减少不能为空', trigger: 'change' }
        ],
        beforeScore: [
          { required: true, message: '变动前华歧系数不能为空', trigger: 'blur' }
        ],
        score: [
          { required: true, message: '变动华歧系数不能为空', trigger: 'blur' }
        ],
        afterScore: [
          { required: true, message: '变动后华歧系数不能为空', trigger: 'blur' }
        ],
        changeScene: [
          { required: true, message: '变动场景 字典 change_scene不能为空', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        hospitalId: null,
        changeType: null,
        beforeScore: null,
        score: null,
        afterScore: null,
        changeScene: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getScoreRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateScoreRecord(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addScoreRecord(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
